import debug from "debug";

export const logMaxFontSize = debug("max-font-size");
